import * as api from '../../api'

export default {
  data() {
    return {
      likes: {'count':0, 'is_liked':false},
    }
  },
  computed: {
    userId: {
      get() {
        return this.$store.getters.userId
      }
    },
  },
  methods: {
    toggleLike(event, uri) {
      if (event) event.preventDefault();

      if (this.userId) {
        var url = '/action/vue/likes/toggle';
        api.post(url, {uri: uri}).then(response => {
          if(response.data.status=='success') this.getLikes(uri);
          else console.log(response.data.error);

        }).catch(e => {
          console.log(e)
        });

        this.showFormMenu  = false
        this.showMenu      = false
        this.showComplaint = false
      }
      else {
        action_user.show_popup_login(event.target);
        stop_bubble(event);
      }
    },

    getLikes(uri){
      if ( uri==null || uri.length==0 ) return;

      if ( window.vue_like_uris==null ) window.vue_like_uris='';
      window.vue_like_uris+=uri+',';

      if ( window.vue_likes_this==null ) window.vue_likes_this={};
      window.vue_likes_this[uri]=this;

      if (window.vue_T_likes!=null) clearTimeout( window.vue_T_likes );

      window.vue_T_likes=setTimeout( ()=>{
        let uris=window.vue_like_uris;
        window.vue_like_uris='';
        api.get('/action/vue/likes/info', {uris:uris}).then(response => {

          for(let res_uri in response.data) {
            let likes=response.data[res_uri];
            window.vue_likes_this[res_uri].likes=likes;
          }
          //this.likes = response.data;

        }).catch(e => {
          console.log(e)
        })
      }, 10 );

    }
  },

  //@TODO нужно добавить в компоненте
  /*created (){
    this.getLikes(this.work.uri);
  }*/
}



//////////////////
// WEBPACK FOOTER
// ./src/components/list/LikesMix.js
// module id = null
// module chunks = 